import styled from 'styled-components/macro';

const $CopyToClipboard = styled.div`
  font-family: ${({ theme }) => theme.font.family.mono};
  display: flex;
`;

export default $CopyToClipboard;
